const getColorSwatchWithUpCharge = ({ colors, colorsUpCharge, paymentFrequency, tooltipLabel, }) => {
    if (Array.isArray(colors) && colors.length) {
        const swatches = colors.map(color => {
            var _a, _b;
            const upCharge = colorsUpCharge === null || colorsUpCharge === void 0 ? void 0 : colorsUpCharge.find(item => (item === null || item === void 0 ? void 0 : item.key) === (color === null || color === void 0 ? void 0 : color.key));
            return {
                key: color === null || color === void 0 ? void 0 : color.key,
                name: color === null || color === void 0 ? void 0 : color.colorName,
                color: color === null || color === void 0 ? void 0 : color.hexValue,
                colorUpCharge: {
                    price: (_a = upCharge === null || upCharge === void 0 ? void 0 : upCharge.msrpMarkup) !== null && _a !== void 0 ? _a : 0,
                    payment: (_b = upCharge === null || upCharge === void 0 ? void 0 : upCharge.frequencyPayment) !== null && _b !== void 0 ? _b : 0,
                    paymentFrequency,
                    tooltipLabel,
                },
                image: color === null || color === void 0 ? void 0 : color.image,
            };
        });
        return swatches;
    }
    return [];
};
export default getColorSwatchWithUpCharge;
